<template>
  <div>
    <div class="content contentTerms">
      <div class="mainDiv">
        <article class="main">
          <section class="topTitle">
            <img src="/static/img/work/argreementLogo.png" alt="">
            Thin Box User Agreement
          </section>
          <section class="intro bold">
            <h4 style="margin-bottom: 5px; ">Dear user ("you"):</h4>
            <p style="word-break: break-all;">
              You are welcome to use the Thin Box platform (including the Thin Box APP and the Thin Box official website
              https://mintstech.cn/, hereinafter referred to as "the Platform"), which is operated by Beijing Mintstech
              Technology Co., Ltd. (hereinafter referred to as "we"). . This platform is a digital art collection that
              provides users to purchase, collect and display blockchain digital collections (registered on the
              blockchain, created by top artists in various fields, and limited release digital art collections.
              hereinafter referred to as "digital collections") platform. Please read the following terms carefully
              before using our services, and using our services indicates that you are aware of and accept these terms
              (hereinafter referred to as "this Agreement"). If you do not accept these terms and conditions, please
              stop using our services immediately. <br />
              Any minors under the age of 18 or those who do not have full capacity for civil conduct shall not register
              an account or use the services provided by us. </p>
          </section>
          <section class="privacy-content">
            <ul>
              <li>
                <div class="rt">
                  <p>I. The subject of the contract and the scope of the agreement</p>
                  <ul>
                    <li>
                      <div class="rt">
                        <p>1.1 Subject and scope of the agreement</p>
                        <p class="desc" style="word-break: break-all;">
                          This agreement is a joint agreement between you and us regarding the use of the services of
                          this platform (https://mintstech.cn/). <br>
                          The validity of the terms of this agreement applies to all products and services we provide,
                          and you shall be bound by this agreement when you enjoy any service on this platform. The
                          products and services under this agreement refer to the Internet products and services
                          published by us, including but not limited to online media, Internet value-added, interactive
                          entertainment, e-commerce, advertising, etc. , barrage, pictures, software, technical codes,
                          etc.).
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt bold">
                        <p>1.2 Prerequisites</p>
                        <p class="desc"><span class="bold">Digital collections are digital collections, and you hereby
                            undertake and warrant that you will primarily use the digital collections on this platform
                            as objects for collection, entertainment and games, and not for investment, speculation or
                            speculation; You hereby promise and guarantee that you will mainly use the blockchain
                            digital certificates of physical collectibles as a tool for anti-counterfeiting
                            traceability, rather than for investment, speculation or speculation, and such commitments
                            and guarantees will serve as the basis for you to enter into this agreement with us.
                            premise. </span>
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt bold">
                        <p>1.3 Disclaimer</p>
                        <p class="desc"><span class="bold">In order for you to make better use of the products and
                            services we provide, please be sure to carefully read and fully understand the terms of this
                            agreement, especially the terms of exemption or limitation of liability. The limitations and
                            disclaimers in this agreement may be highlighted in bold to remind you. <br>When you
                            register/login to this platform, it is deemed that you have fully read and accepted all the
                            terms of this agreement, and you agree that this agreement is legally binding on both you
                            and us.
                          </span></p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>1.4 Protocol Components</p>
                        <p class="desc">
                          Except as expressly provided in this agreement, for the products and services published by us
                          and sold by copyright owners or other rights holders, we have the right to make use of a
                          separate product and service agreement (hereinafter referred to as the "single product
                          agreement") on the basis of this agreement. Specifications, you must understand and confirm
                          separately when using the relevant products or services. In the event of any conflict between
                          the Single Product Agreement and this Agreement, the Single Product Agreement shall prevail.
                          If you use the product or service, it is deemed to accept the relevant single product
                          agreement. <br />
                          The content of this agreement also includes all the various rules, announcements or notices
                          that we have published or may publish in the future, as well as the single product agreement
                          that you agree to when using a specific product or service. Posting is an integral part of
                          this Agreement and is legally binding on both you and us.
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt bold">
                        <p>1.5 Amendments to the Agreement</p>
                        <p class="desc">
                          <span class="bold">
                            We have the right to amend this agreement and/or various rules from time to time as needed
                            (including but not limited to formulating new terms and amending existing terms).
                            Announcement of changes without separate notice to you. Once the revised agreement and rules
                            are announced, they will take effect immediately or at a specific time specified in the
                            announcement. If you continue to use our products or services after the above announcement
                            is revised, it is deemed that you have read, understood and accepted the revised agreement
                            and rules. If you do not agree to the revision, you should immediately stop using this
                            platform.
                          </span>
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>

              <li>
                <div class="rt">
                  <p>Second, account registration, use and security</p>
                  <ul>
                    <li>
                      <div class="rt">
                        <p>2.1 Registration Qualifications</p>
                        <p class="desc">
                          You confirm that <span class="bold">You should be at least 18 years old and have full capacity
                            for civil conduct before you can register to use this platform. </span>If you are under the
                          age of 18 or do not have full capacity for civil conduct, you should not use this platform,
                          otherwise you and your legal guardian shall bear all the consequences arising therefrom in
                          accordance with the law.
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>2.2 Account registration</p>
                        <p class="desc">
                          When registering, you should use your mobile phone number, SMS verification code, email
                          address, email verification code and friend invitation code, and fill in your nickname and
                          gender to complete the registration. After you fill in the information as prompted on the
                          registration page, read and agree to this agreement, and complete all the registration
                          procedures, you can use the account we provided to you and become our user. Your account is
                          the credential you use to log in, use our services, and purchase digital collections<span
                            class="bold">But please note that we only allow you to use this account for personal, not
                            commercial purposes. We reserve the ownership of the account and service data and records
                            related to registration and use of the account, including but not limited to all
                            registration, login, service logs, customer service records and related usage data. </span>
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>2.3 Account Information</p>
                        <p class="desc">
                          You should accurately provide and timely update your account information in accordance with
                          the requirements of laws and regulations or the prompts on the corresponding pages to make it
                          true, timely, complete and accurate. Integrity is responsible. If the information you provide
                          is wrong, inaccurate, outdated or incomplete, we may send you a notice of inquiry and/or
                          request for correction, and you should cooperate in providing or updating relevant information
                          and materials as required by us. <span class="bold">Because the information you fill in is
                            untrue, untimely, incomplete or inaccurate, you should assume that you cannot use our
                            account (cannot register successfully, or the account is frozen or cancelled) or use
                            Consequences and losses of limited functions in the process. </span>
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>2.4 Nickname</p>
                        <p class="desc">You can set a nickname for your account. The nickname you set must not infringe
                          or allegedly infringe the legal rights of others. Observe the following rules when setting a
                          nickname:</p>
                        <ul>
                          <li>
                            <div class="rt">
                              <p>(1) Do not register with the real name, font size, stage name or pseudonym of party and
                                state leaders or other social celebrities;</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>(2) Not registered in the name of a state agency or other agency;</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>(3) Do not register accounts with uncivilized and unhealthy names, or accounts with
                                discriminatory, insulting, obscene words;</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>(4) Do not register an account that is likely to cause ambiguity and cause
                                misunderstanding by others;</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>(5) Do not endanger national security, divulge state secrets, subvert state power, or
                                undermine national unity;</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>(6) The honor and interests of the country shall not be damaged, and the public
                                interest shall not be damaged;</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>(7) Do not incite ethnic hatred, ethnic discrimination, or destroy ethnic unity;</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>(8) Do not undermine the national religious policy, promote cults and feudal
                                superstitions;</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>(9) Do not spread rumors, disrupt social order, and undermine social stability;</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>(10) Not to spread obscenity, pornography, gambling, violence, murder, terror or
                                instigate crime;</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>(11) Do not insult or slander others or infringe on the legitimate rights and interests
                                of others;</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>(12) Must not violate the Constitution or laws and regulations;</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>(13) shall not contain other content prohibited by laws and administrative regulations.
                              </p>
                            </div>
                          </li>
                          <li>

                            <div class="rt">
                              <p class="bold">
                                If the nickname you set is suspected of infringing on the legitimate rights and
                                interests of others or contains other content prohibited by laws and administrative
                                regulations, we have the right to refuse or terminate the provision of some or all of
                                the software services to you. We do not assume any responsibility for this, and you will
                                be liable for any direct or indirect losses and adverse consequences arising therefrom.
                              </p>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>2.5 Prohibition of loan</p>
                        <p class="desc bold">
                          Your account is limited to your own use. Without our written consent, it is prohibited to
                          give, borrow, rent, transfer, sell or otherwise permit others to use the account in any form.
                          If we find or have reasonable grounds to believe that the user is not the initial registrant
                          of the account, we have the right to temporarily or terminate the provision of services to the
                          registered account, and have the right to cancel the account without taking legal
                          responsibility for the user who registered the account.
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>2.6 Prohibit malicious registration</p>
                        <p class="desc">Malicious registration of accounts is prohibited, including but not limited to
                          frequent and batch registration of accounts. If we find or have reasonable reasons to believe
                          that you have maliciously registered an account, we have the right to reject your malicious
                          registration or cancel the maliciously registered account. </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>2.7 Account Safekeeping</p>
                        <p class="desc">
                          You must keep your account properly and not disclose your account to others under any
                          circumstances. You need to ensure that you leave the platform in the correct steps after
                          purchasing digital collections and using our services. You assume full legal responsibility
                          for the activities you engage in in the name of your registered account, including but not
                          limited to the purchase of digital collections on this platform, payment, information
                          disclosure, information release, online clicks to agree or submit various rules and
                          agreements, etc. all legal consequences. <span class="bold"> We do not assume any
                            responsibility for the loss and consequences of account disclosure caused by attack, fraud,
                            theft, etc. on your account due to your behavior or other factors. </span>
                          If you find that others are using your account without authorization, you should notify us
                          immediately, and we will assist you to freeze your account or perform other security settings.
                          <span class="bold"> Please understand that it takes reasonable time for us to take action on
                            your request, and we are not responsible for the consequences (including but not limited to
                            any loss to you) that have been generated before taking action and caused by you (including
                            but not limited to any loss to you). responsibility. </span>
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>2.8 Real-name authentication</p>
                        <p class="desc">In order for you to better use our services and ensure the security of your
                          account, we may require you to complete real-name authentication and/or "know your customer"
                          in accordance with relevant laws and regulations Investigate and ask you to provide further
                          relevant information.</p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>2.9 Account freezing and appeal</p>
                        <p class="desc">We have the right to freeze your account (all or part of permissions or
                          functions) and notify you through appropriate means and channels if the following
                          circumstances occur:</p>
                        <ul>
                          <li>
                            <div class="rt">
                              <p>(1) Violating this agreement, as well as the relevant rules, management specifications,
                                service descriptions and other usage agreements/terms for the purchase, display and
                                service of digital collections;</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>(2) Violating the provisions of national laws, regulations, policies and legal
                                documents;</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>(3) You have been complained by others, and the other party has provided relevant
                                evidence, but you have not provided contrary evidence as required by us;</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>(4) Based on reasonable analysis, we judge that your account operation is abnormal,
                                conduct suspicious transactions or have the risk of fraud and money laundering;</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>(5) In order to protect the legitimate rights and interests of us and other users;</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>(6) The state authority requires it. </p>
                            </div>
                          </li>
                        </ul>
                        <p class="desc">
                          <span class="bold">
                            If your account is frozen, you will temporarily not be able to use your account to purchase
                            digital collections until it is unfrozen. We have the right to delete relevant illegal
                            content at any time without notice, and deal with the offending account according to the
                            circumstances of the behavior, including but not limited to warning, deleting some or all
                            subscribers, restricting or prohibiting the use of all or part of the functions, account ban
                            or even cancellation , and has the right to announce the result of the handling according to
                            the specific circumstances.
                          </span>
                        </p>
                        <p class="desc">
                          You can apply to us to lift the above freeze through the appeal process. For the security of
                          your account, you should cooperate and truthfully provide your identity certificate and
                          related materials, as well as other information or documents requested by us, so that we can
                          conduct verification and investigation. We have the right to decide whether to agree to your
                          appeal request.
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>

              <li>
                <div class="rt">
                  <p>Three, account cancellation</p>
                  <p class="desc">
                    You have the right to voluntarily cancel your account. You can contact us to cancel your account
                    through the contact information provided on the "About Us" page of this platform (except as
                    otherwise provided by laws and regulations or in this policy).
                    <span class="bold">
                      Once you cancel your account, you will not be able to log in to the original account to use the
                      products and services we provide and will automatically give up your existing rights, so please
                      exercise caution.
                    </span>
                    <br />
                    After your account is cancelled voluntarily by you or forced to be cancelled due to violation of the
                    agreement in Article 2 above, you may be responsible for the following consequences including but
                    not limited to:</p>
                  <ul>
                    <li>
                      <div class="rt">
                        <p>3.1 Once the account is cancelled, you will not be able to log in and use the account, that
                          is, you will no longer be able to log in, use, and continue to use all products and services
                          of this platform with this account;</p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>3.2 Once the account is cancelled, all content, information, data, records and digital
                          collections you have purchased under the products and services of this platform that you have
                          logged in and used through the account will be frozen, including but not limited to :</p>
                        <ul>
                          <li>
                            <div class="rt">
                              <p>(1) The digital certificate of the digital collection purchased by the account or the
                                obtained physical collection;</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>(2) Personal data (such as avatar, nickname, etc.) and binding information (such as
                                binding mobile phone number, email, etc.) under the account, as well as your other
                                personal information under the account. At the same time, you are no longer entitled to
                                the "<a href="/conceal" style="color:#83878B;font-weight:bold">Your rights to personal
                                  information stipulated in the Thin Box Privacy Policy</a>, unless otherwise stipulated
                                by laws and regulations;</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>(3) All content published by the account (for example: articles, pictures, comments,
                                interactions, etc.);</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>(4) All other content, information, data, records (such as collections, etc.) related
                                to the account. </p>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>3.3 You agree to give up the rights and future expected benefits that have been generated but
                          not consumed by the account during the use of the platform's products and services by
                          canceling the account. That is, once the account is cancelled, all your rights and interests
                          under the account will be automatically cleared and voided, including but not limited to:
                        </p>
                        <ul>
                          <li>
                            <div class="rt">
                              <p>(1) Your account balance that has not been withdrawn;</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>(2) The future income rights and interests of the content you publish on this platform;
                              </p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>(3) Your various rights and interests on this platform;</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>(4) Other rights and interests that have been generated but not consumed or expected
                                future income. </p>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          3.4 Once your account is cancelled, it cannot be recovered, even if you apply to us again to
                          register an account on this platform with the same mobile phone number after cancellation, the
                          account will be a brand new user account at this time. Therefore, we kindly remind you to back
                          up the content that needs to be backed up in advance before actively applying for
                          cancellation, withdraw the balance that needs to be withdrawn first, make proper arrangements
                          for other interests, and make a cancellation decision after careful consideration;
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>3.5 Once the account is cancelled, the agreements, documents, etc. you have signed with us
                          will be terminated accordingly (except those that have been agreed to continue to be effective
                          or otherwise provided by laws and regulations);</p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>3.6 Other results due to account cancellation (possibly). </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>

              <li>
                <div class="rt">
                  <p>four, our service</p>
                  <ul>
                    <li>
                      <div class="rt">
                        <p>4.1 Browse, follow, share and display digital collections</p>
                        <p class="desc">
                          In the process of browsing this platform, we provide you with functions such as information
                          classification, keyword retrieval, screening, attention, and display to better match your
                          needs. You can browse, follow, share the digital collections you are interested in, and show
                          others the digital collections you have purchased.
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>4.2 Buy Blind Box</p>
                        <p class="desc">
                          Blind boxes are sold by the copyright owner and related rights holders (hereinafter referred
                          to as "sellers") through this platform. The types and quantities of collectibles contained in
                          each blind box are different. You can view them on the details page of the blind box, but you
                          will Only know the type and quantity of digital collections (for example: works of art,
                          designs, paintings, etc. presented in the form of videos or photos), but not the specific
                          content. The seller has the right to independently determine the type, price and quantity of
                          the blind box. The quantity of each blind box is different, and it will be sold out. <br />
                          You can enter the "Blind Box" navigation page on the platform, select the blind box on sale,
                          enter the details of the blind box, and learn about the types of blind boxes and other
                          information. After the waiting room is open, you can join the waiting room, enter the queue
                          when you arrive at the blind box purchase time, and you can buy the blind box when it is your
                          turn in the queue. Depending on the type of blind box you buy, you will collect different
                          digital collectibles.
                        </p>
                      </div>
                    </li>

                    <li>
                      <div class="rt">
                        <p>4.3 Limited time event</p>
                        <p class="desc">You can get corresponding rewards by participating in limited-time events on
                          this platform, or accepting certain challenge tasks, collecting digital collections designated
                          by events or tasks. </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>4.4 Advertising and Marketing</p>
                        <p class="desc">
                          By submitting information (including but not limited to email address, phone number, name,
                          etc.) on this platform, you are deemed to agree that we or entrust third-party advertisers to
                          contact you by email, in-site letter, mobile phone text message, phone call, etc. You send
                          newsletters, advertisements and other commercial pushes. <br />
                          You can unsubscribe from advertisements according to the unsubscribe method described in the
                          commercial advertisement information, or you can contact us to cancel the advertisement push
                          through the contact information provided on the "About Us" page of this platform, but you must
                          not block or filter advertisement information without our permission. . </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>4.5 Dispute Handling</p>
                        <p class="desc">If the physical products you purchase through the platform have quality problems
                          or other disputes, you can report to the platform, the platform will provide you with the
                          contact information of the seller, and you will protect the rights of the seller . <br>
                          For digital collections you purchase through the platform, or if disputes arise during the use
                          of our services, you may contact us for mediation, negotiation and resolution. You can also
                          file a complaint with the relevant administrative department or file a lawsuit with the
                          competent court agreed in this agreement. </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>4.6 service upgrade</p>
                        <p class="desc">
                          In order to improve the user experience and improve the service content, we will improve,
                          enhance and further develop the services of this platform. You understand and agree that we
                          have the right to update the services of this platform without special notice to you, or to
                          perform some functions of this platform. change or restriction. </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        4.7
                        For the goods (including digital collections) you purchase through this platform according to
                        this agreement, you will have the right to request a VAT invoice equal to the full price you
                        actually paid, and initiate an invoicing request through the platform. The platform will feed
                        back your billing request to the actual seller. You acknowledge and agree that the invoice will
                        be issued by the actual seller.
                      </div>
                    </li>
                  </ul>
                </div>
              </li>

              <li>
                <div class="rt">
                  <p>V. Specifications</p>
                  <p class="desc">
                    You have the right to enjoy the Internet technical services and information services provided by
                    this platform, purchase and display digital collections through this platform, or obtain blockchain
                    digital certificates for physical collections.
                    <br>
                    <span class="bold">
                      Subject to your compliance with this Agreement, we grant you a limited, non-transferable,
                      non-exclusive, revocable, personal, non-commercial use of the Platform. In any event, our content
                      and services are licensed for your personal use only and may not be sold or transferred. We
                      reserve all rights not specifically granted herein. In the process of using our services, you must
                      follow the following principles:
                    </span>
                  </p>
                  <ul>
                    <li>
                      <div class="rt">
                        <p>
                          5.1 You shall not produce, reproduce, publish, or disseminate information containing the
                          following contents or engage in related acts, nor shall you facilitate the production,
                          reproduction, publication, dissemination of information containing the following contents or
                          engage in related acts. The content described in this article refers to any content produced,
                          uploaded, copied, published, or disseminated during your use of the services under this
                          agreement, including but not limited to account avatar, nickname, evaluation and other
                          information, or text, voice, picture, video, etc. , pictures and texts, etc. to send, reply or
                          automatically reply to messages and related link pages, as well as other content generated by
                          using the account or the services of this platform.
                        </p>
                        <ul>
                          <li>
                            <div class="rt">(1) Those who oppose the basic principles established by the Constitution;
                            </div>
                          </li>
                          <li>
                            <div class="rt">(2) Endangering national security, divulging state secrets, subverting state
                              power, and undermining national unity;</div>
                          </li>
                          <li>
                            <div class="rt">(3) Damage to national honor and interests;</div>
                          </li>
                          <li>
                            <div class="rt">(4) Distorting, defaming, blaspheming, denying the deeds and spirits of
                              heroes and martyrs, and infringing upon the names, portraits, reputation, and honor of
                              heroes and martyrs by insulting, slandering or other means;</div>
                          </li>
                          <li>
                            <div class="rt">(5) Advocating terrorism, extremism or inciting terrorist or extremist
                              activities;</div>
                          </li>
                          <li>
                            <div class="rt">(6) Those who incite ethnic hatred, ethnic discrimination, or undermine
                              ethnic unity;</div>
                          </li>
                          <li>
                            <div class="rt">(7) Those who undermine the national religious policy and promote cults and
                              feudal superstitions;</div>
                          </li>
                          <li>
                            <div class="rt">(8) Spreading rumors and disrupting economic and social order;</div>
                          </li>
                          <li>
                            <div class="rt">(9) Spreading obscenity, pornography, gambling, violence, murder, terror or
                              instigating crime;</div>
                          </li>
                          <li>
                            <div class="rt">(10) Insulting or slandering others, infringing on their reputation, privacy
                              and other legitimate rights and interests;</div>
                          </li>
                          <li>
                            <div class="rt">(11) Violating the "seven bottom lines" of the bottom line of laws and
                              regulations, the bottom line of the socialist system, the bottom line of national
                              interests, the bottom line of citizens' legitimate rights and interests, the bottom line
                              of social public order, the bottom line of morality, and the bottom line of information
                              authenticity .
                            </div>
                          </li>
                          <li>
                            <div class="rt">(12) Prohibited by relevant laws and regulations or this agreement, relevant
                              agreements, rules, etc. </div>
                          </li>
                        </ul>
                        <p class="desc">At the same time, you should prevent and resist the production, reproduction,
                          and distribution of inappropriate information containing:</p>
                        <ul>
                          <li>
                            <div class="rt">(1) Exaggerated title is used, and the content is seriously inconsistent
                              with the title;</div>
                          </li>
                          <li>
                            <div class="rt">(2) Hype up scandals, scandals, bad deeds, etc.;</div>
                          </li>
                          <li>
                            <div class="rt">(3) Improper comments on natural disasters, major accidents and other
                              disasters;</div>
                          </li>
                          <li>
                            <div class="rt">(4) Sexually suggestive, sexually provocative, etc. that are easy to cause
                              sexual associations;</div>
                          </li>
                          <li>
                            <div class="rt">(5) Showing blood, horror, cruelty, etc. that cause physical and mental
                              discomfort;</div>
                          </li>
                          <li>
                            <div class="rt">(6) Inciting crowd discrimination, regional discrimination, etc.;</div>
                          </li>
                          <li>
                            <div class="rt">(7) Promote vulgar, vulgar, kitsch content; </div>
                          </li>
                          <li>
                            <div class="rt">(8) It may cause minors to imitate unsafe behaviors and behaviors that
                              violate social morality, induce minors’ bad habits, etc.;</div>
                          </li>
                          <li>
                            <div class="rt">(9) Other content that adversely affects the network ecology. </div>
                          </li>
                        </ul>
                      </div>
                    </li>

                    <li>
                      <div class="rt">
                        <p>
                          5.2 Do not use our services to engage in illegal and criminal activities, including splitting
                          the country, instigating others to commit crimes, infringing on computer security systems,
                          interfering with or disrupting network services, etc., endangering national security, fraud,
                          money laundering and engaging in or funding other illegal and criminal activities or damage to
                          society act in the public interest.
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>5.3 Comply with this Agreement and all related agreements, regulations and procedures, and
                          must also follow Internet-related procedures and practices. </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>5.4 Do not use or conduct any behaviors that endanger computer network security using or
                          against our services, including but not limited to:</p>
                        <ul>
                          <li>
                            <div class="rt">(1) Activities that endanger network security such as illegally intruding
                              into other people's networks, interfering with the normal functions of other people's
                              networks, stealing network data, etc.;</div>
                          </li>
                          <li>
                            <div class="rt">(2) Provide programs and tools specially used for intrusion into the
                              network, interfering with the normal functions and protective measures of the network,
                              stealing network data and other endangering network security activities;</div>
                          </li>
                          <li>
                            <div class="rt">(3) Provide technical support, advertising promotion, payment and settlement
                              and other assistance for others who know that they are engaged in activities that endanger
                              network security;</div>
                          </li>
                          <li>
                            <div class="rt">(4) Use unauthorized data or access unauthorized servers/accounts;</div>
                          </li>
                          <li>
                            <div class="rt">(5) Unauthorized access to public computer networks or other people's
                              computer systems and deletion, modification, and addition of stored information;</div>
                          </li>
                          <li>
                            <div class="rt">(6) Without permission, attempt to probe, scan, test the weaknesses of the
                              service system or network, or conduct other acts that undermine network security;</div>
                          </li>
                          <li>
                            <div class="rt">(7) Attempts to interfere with or disrupt the normal operation of the
                              service system or platform, intentionally spread malicious programs or viruses, and other
                              acts that disrupt and interfere with normal network information services;</div>
                          </li>
                          <li>
                            <div class="rt">(8) Forge TCP/IP packet names or partial names. </div>
                          </li>
                        </ul>
                      </div>
                    </li>

                    <li>
                      <div class="rt">
                        <p>5.5 Do not reverse engineer, disassemble, compile or otherwise attempt to discover the source
                          code of this platform. </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          5.6 Do not submit or publish false information; do not defraud, force, induce other users to
                          follow, click on linked pages or share information; do not use robots or automated programs to
                          create accounts or purchase digital collections in false or fraudulent ways; do not
                          impersonate others, use Create an account or buy a digital collection using someone else's
                          email address.
                        </p>
                      </div>
                    </li>

                    <li>
                      <div class="rt">
                        <p>5.7 Do not use any plug-ins, plug-ins, systems or third-party tools that are not authorized
                          or licensed by us to interfere with, disrupt, modify or otherwise affect the normal operation
                          of the Service. </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>5.8 You should use your own legal funds to purchase digital collections. </p>
                      </div>
                    </li>

                    <li>
                      <div class="rt">
                        <p>
                          5.9 You must not purchase digital collections by illegal means, such as stealing credit cards
                          or using other payment methods or mechanisms that you are not authorized to use; you must not
                          obtain blockchain digital certificates for physical collectibles by illegal means, such as
                          stealing other people's possessions or possessions Physical collectibles, and obtain a digital
                          certificate based on that physical collectible.
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          5.10 Your purchases should be based on real consumption and collection needs, not for
                          investment or speculative purposes, and there must be no malicious purchase of digital
                          collections, price manipulation or money laundering using digital collections and other
                          behaviors that disrupt the normal order of the platform. Based on the need to maintain
                          platform order and platform security, we can actively execute operations such as closing
                          relevant orders when we find the above situation.
                        </p>
                      </div>
                    </li>

                    <li>
                      <div class="rt">
                        <p>5.11 Digital collections on this platform may not be used as general equivalents or proofs
                          for the purchase of other assets. </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>5.12 ​​Do not purchase any other user accounts of this platform or digital collections sold
                          by this platform outside this platform. If you purchase digital collections sold on this
                          platform in other ways, you shall be responsible for the legal consequences. </p>
                      </div>
                    </li>

                    <li>
                      <div class="rt">
                        <p>
                          5.13 Digital collections shall not be split into shares for trading outside this platform, and
                          digital collections shall not be traded through centralized bidding, call auction, continuous
                          bidding, electronic matching, and market-making transactions. The digital certificates of
                          physical collectibles shall not be traded or hyped outside this platform, and the digital
                          certificates of physical collectibles shall not be traded through centralized bidding,
                          collective bidding, continuous bidding, electronic matching, and market-making transactions.
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          5.14 Please ensure that any content (including but not limited to avatar, name, account
                          introduction, or text, pictures, audio, video, links, etc., or other use of this other content
                          generated by platform services) shall have legitimate rights and interests, and shall not
                          infringe upon the patent, copyright, trademark and other intellectual property rights,
                          reputation rights, privacy rights or any other legitimate rights and interests of us and our
                          affiliated companies, or any other third party, or engage in Conduct that harms our interests
                          or adversely affects us. <span class="bold">If the content in your account has a rights
                            dispute or violates the legitimate rights and interests of any third party, you shall bear
                            all legal responsibilities. </span></p>
                      </div>
                    </li>

                    <li>
                      <div class="rt">
                        <p>5.15 Unless you have complied with the other provisions of this Agreement or have obtained
                          our prior permission, you shall not, for any purpose, engage in or assist others to engage in
                          the following acts:</p>
                        <ul>
                          <li>
                            <div class="rt">(1) Download, copy, read, adopt, display, share, forward, disseminate,
                              upload, publish, and distribute our service content;</div>
                          </li>
                          <li>
                            <div class="rt">(2) Modify, edit, organize, arrange or otherwise interpret our service
                              content;</div>
                          </li>
                          <li>
                            <div class="rt">(3) Transfer, resell and lease our service content;</div>
                          </li>
                          <li>
                            <div class="rt">(4) Using any form of identification methods including but not limited to
                              special logos, special codes, etc., to generate traffic, guide, transfer, or hijack the
                              information content of our service by itself or assist a third party and other adverse
                              effects.
                            </div>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>5.16 With our prior written permission, your sharing, forwarding and other behaviors of the
                          information content of our related services should also comply with the following
                          specifications:</p>
                        <ul>
                          <li>
                            <div class="rt">
                              (1) For relevant data such as crawling, counting, and obtaining related search hot words,
                              hit rate, classification, search volume, click-through rate, reading volume, etc., the
                              above data shall not be published or provided in any way without our prior written
                              consent. , leaked to any third party;</div>
                          </li>
                          <li>
                            <div class="rt">
                              (2) It is not allowed to make any changes to the source page of this platform, including
                              but not limited to the home page link, advertising system link and other entrances of this
                              platform, nor to block, insert, or bounce the display of the source page of this platform
                              in any form. windows, etc.; </div>
                          </li>
                          <li>
                            <div class="rt">(3) Safe, effective and strict measures shall be taken to prevent our
                              information content from being illegally obtained by third parties in any form including
                              but not limited to web crawler programs;</div>
                          </li>
                          <li>
                            <div class="rt">(4) The relevant data content shall not be used for purposes beyond the
                              scope of our written permission, for any form of sales and commercial use, or to disclose
                              to third parties, provide or allow third parties to use them in any way use;</div>
                          </li>
                          <li>
                            <div class="rt">(5) The behavior of users to share or forward the information content of our
                              related services to any third party shall also abide by other norms and standards we have
                              formulated for this purpose. </div>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          5.17 In order to protect data security, you shall not engage in, or facilitate, including but
                          not limited to the following:
                        </p>
                        <ul>
                          <li>
                            <div class="rt">
                              (1) Collect, copy, store, use or transmit other user data without the explicit consent of
                              other users, or without truthfully disclosing data usage, scope of use and other relevant
                              information to other users, infringing on the legitimate rights and interests of other
                              users;</div>
                          </li>
                          <li>
                            <div class="rt">
                              (2) Use other users' personal information such as account numbers, nicknames and other
                              personal information for any purpose that is not authorized by the user and us;</div>
                          </li>
                          <li>
                            <div class="rt">(3) Attempts to find, track, associate, mine, and obtain personal
                              information such as user account numbers, mobile phone numbers, and dates of birth by
                              reflection;</div>
                          </li>
                          <li>
                            <div class="rt">(4) Capture any user's information or any information and data related to
                              this service through various programs, software, etc.;</div>
                          </li>
                          <li>
                            <div class="rt">(5) Use any third-party software, plug-ins, plug-ins, systems, etc. without
                              our authorization to view or obtain any relevant information, data, etc. of us and our
                              partners or users contained in this service content;</div>
                          </li>
                          <li>
                            <div class="rt">
                              (6) Other acts that endanger data security.
                            </div>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          5.18 If you violate any of the above provisions when using our services, we can judge and deal
                          with it at our own discretion and require you to correct or take all necessary measures
                          (including but not limited to deleting your uploaded content, suspending or terminating your
                          use of this platform, deleting your images and descriptions of digital collections, confiscate
                          all digital collections you purchased) to mitigate the impact of your misconduct, and have the
                          right to terminate the service to you at any time without any prior notice and be held
                          accountable .
                          <span class="bold">
                            If you violate any of the above provisions and have any legal consequences, you should
                            independently assume all legal responsibilities in your own name, and if you cause our
                            losses or cause us to be claimed by a third party, you should fully compensate us for all
                            losses and expenses (including but Not limited to various compensation fees, litigation
                            agency fees and other reasonable expenses for this purpose)
                          </span>
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          5.19 If you find that the content (including but not limited to pictures, videos, text works,
                          etc.) posted by users on this platform infringes your prior rights, you can contact us at
                          info@mints.cn to report and provide corresponding proof materials , we will take timely
                          measures to stop the infringement after verification.
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>

              <li>
                <div class="rt">
                  <p class="bold">VI. RIGHTS AND RESTRICTIONS OF DIGITAL COLLECTIONS</p>
                  <ul>
                    <li>
                      <div class="rt">
                        <p>
                          6.1 You can purchase works created by top creators in various fields through this platform and
                          registered on the blockchain. Based on the encryption, non-tampering and irreplaceability of
                          blockchain technology, the blockchain registration is the only <span of the tenure document
                            class="bold">Digital Collection</span>After you acquire and purchase a digital collection in
                          accordance with this agreement, your rights to the digital collection will be limited, and you
                          can only list the digital collection in your collection, enjoy, browse and show your digital
                          collection to other users.
                          <span class="bold"> The creator, creation and on-chain time, purchaser and other information
                            in the metadata of the digital collection cannot be tampered with once confirmed. The
                            blockchain registration will be counted in your account and registered in the [Digital
                            Collection Warrant Registration Chain] that we operate and maintain, as your proof of
                            holding the digital collection, so as to realize the immutability and uniqueness of your
                            digital collection rights registration. sex. You understand and agree that your email
                            address may be disclosed in order to make the aforementioned purchases and registrations. In
                            addition, there may be a delay in the registration of digital collections on the blockchain,
                            and you cannot view the blockchain registration of digital collections immediately after
                            purchase. After you purchase a digital collection and complete the registration, you can log
                            in to this platform through your account to view the blockchain registration certificate of
                            the digital collection, but you have no right to request to extract the blockchain
                            registration certificate or register the blockchain Transferring the certificate of
                            entitlement to your other e-wallets does not have the right to require us to import the
                            digital collection or its blockchain registration certificate of entitlement to other
                            platforms or register your digital collection on any other platform or institution. </span>
                        </p>
                      </div>
                    </li>

                    <li>
                      <div class="rt">
                        <p>
                          6.2 For the digital collections you purchased through this platform in accordance with this
                          agreement, the right holder will grant you a non-exclusive, non-exclusive, non-sublicensable
                          collection that is limited to personal non-commercial purposes within the validity period of
                          the copyright, License to use and display your digital collection
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          6.3 Except for the content expressly stipulated in this agreement, or you have obtained the
                          written authorization of the copyright owner and related rights holders, no matter you obtain
                          digital collections through this platform or any other means, neither we nor the copyright
                          holders and related rights holders will grant you any rights to the digital collection. Any
                          rights and licenses (including but not limited to copyright) in the Digital Collection.
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p><span class="bold">6.4 The license granted in clause 6.2 above applies only for the time
                            frame in which you own the Digital Collection. </span>If you cancel your account or for any
                          reason give up your purchased Digital Collection, the license granted in Section 6.2 above
                          will expire immediately without notice.
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt bold">
                        <p class="bold">6.5 You shall not, and shall not allow any third party to: </p>
                        <ul>
                          <li>
                            <div class="rt bold">(1) reproduce, distribute, modify, adapt, translate, or otherwise
                              develop any derivative works of the Digital Collection;</div>
                          </li>
                          <li>
                            <div class="rt bold">
                              (2) Use digital collections for any commercial purpose, including but not limited to back
                              covers, covers, illustrations for films, videos or any other form of media, paper or
                              electronic publications (including but not limited to audio and video publications). ,
                              content, software or mobile applications, online or offline advertising, sales or
                              promotions, and any other form of commercial activity, advertising, promotion of digital
                              collections, etc.;
                            </div>
                          </li>
                          <li>
                            <div class="rt bold">
                              (3) Use or associate digital collections with any use or scene that violates national
                              laws, regulations, policies, social order and good customs, pornography, obscenity,
                              violence and cruelty, illegal speech, immorality and/or infringes the legal rights and
                              interests of third parties;
                            </div>
                          </li>
                          <li>
                            <div class="rt bold">(4) Put digital collections (sectionsor all) as its own or other third
                              party's trademarks, service marks, logos, logos, designations of origin or other
                              commercial designations;</div>
                          </li>
                          <li>
                            <div class="rt bold">(5) Attempt to trademark, copyright, or otherwise acquire additional
                              intellectual property rights for the digital collection you purchased;</div>
                          </li>
                          <li>
                            <div class="rt bold">(6) Store digital collections on any platform, system, Internet, shared
                              hard drive or similar device for the purpose of sharing or transferring information or
                              content for others to browse, download, Retrieval.
                            </div>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          6.6 You understand and agree that your purchase of digital collections on this platform is
                          irrevocable, since the purchase will be recorded in detail on the blockchain once it occurs,
                          such as your cognitive error, operational error, third-party fraud We cannot revoke or restore
                          digital collections purchased for other reasons, and you shall be fully responsible for your
                          purchases. We especially remind you that digital collections sold on this platform do not
                          support seven-day unreasonable returns. Once you have purchased a digital collection, you have
                          no right to withdraw, request a return, exchange or refund the digital collection.
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          6.7 You understand and agree that your purchase of digital collections on this platform may
                          generate certain taxes and fees in accordance with applicable laws and regulations, and you
                          shall be responsible for paying all taxes and fees on time and bear all legal responsibilities
                          that may arise when you fail to perform relevant obligations. You are not entitled to deduct
                          other additional charges, such as taxes, from payments you owe us or other users.
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          6.8 If the digital collection you purchased contains third-party intellectual property rights,
                          you understand and agree that you have no right to use the third-party intellectual property
                          rights outside the digital collection, such as selling and distributing goods containing
                          third-party intellectual property rights. Your right to use digital collections may be
                          restricted by third-party intellectual property rights holders, and you should comply with the
                          restrictions when we notify you in writing of such restrictions, otherwise, you should bear
                          all possible legal consequences and responsibilities.
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>

              <li>
                <div class="rt bold">
                  <p>7. Rights and limitations of digital certificates for physical collections</p>

                  <ul>
                    <li>
                      <div class="rt">
                        <p>
                          7.1 You understand and agree that the digital certificates of physical collectibles you obtain
                          through this platform are registered on the blockchain. Based on the encryption, non-tampering
                          and irreplaceability of blockchain technology, the blockchain registration is Proof of holding
                          the physical collectible item(s).
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          7.2 The digital certificates of physical collectibles do not have exchange value, but are only
                          tools for right confirmation, and cannot be used for speculation, over-the-counter
                          transactions and any commercial purposes. If we find that your account has abnormal behaviors
                          such as digital certificates for hyping physical collectibles, suspected violations of laws or
                          regulations, or behaviors prohibited by this agreement, we have the right to take necessary
                          restrictive measures, including but not limited to freezing your account.
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          7.3 When the ownership of the physical collection is transferred, the owner of the physical
                          collection can apply for the gift of the digital certificate of the physical collection on
                          this platform, and the platform will assist the holder of the physical collection within a
                          reasonable time after the review is passed. The user completes the transfer of the digital
                          certificate. In order to prevent speculation, you understand and agree that you need to hold
                          【180】Only available in Japan.
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          7.4 You understand and agree that, in view of the particularity of blockchain services, this
                          platform has the right to close the gift function of digital certificates for physical
                          collectibles at any time.
                        </p>
                      </div>
                    </li>

                  </ul>
                </div>
              </li>

              <li>
                <div class="rt">
                  <p>Eighth, intellectual property protection</p>
                  <ul>
                    <li>
                      <div class="rt">
                        <p>
                          For the content of this platform, we will protect our and your intellectual property rights
                          according to the following rules:
                          <br />
                          8.1 Unless otherwise agreed, the ownership and all legal rights of all elements such as the
                          content, code, data, etc. of this platform, as well as all intellectual products therein
                          (including but not limited to digital collections, systems, methods, information, codes,
                          software, services, The intellectual property rights in the organization, content, data,
                          technology, programs, web pages, text, pictures, diagrams, appearance, designs, presentations,
                          applications, and all other elements) and the rights to the data on this platform belong to us
                          . You may not reverse engineer, disassemble, decompile, or otherwise attempt to discover our
                          source code, rent, lend, modify, link, assemble, publish, publish, reprint, Copy, copy, sell,
                          resell, access, scrape, mirror or use any part of the content, data, code and design.
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          8.2 We respect your intellectual property rights. In order to provide you with our services
                          (for example: to display your uploaded text, voice, pictures, videos, graphics, etc.), you
                          agree to grant us a worldwide, free, transferable, non-exclusive and irrevocable right, Use
                          all information and data you provide or generate to us in the use of our services, provided
                          that it does not infringe on your trade secrets and personal information. In addition, we will
                          not use, modify, reproduce, publicly transmit, alter, distribute, distribute or publicly
                          publish your intellectual property rights unless we have obtained your consent.
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          8.3 All trademarks, service marks and numbers related to this platform and its content are the
                          exclusive property of us or our licensors. Without our prior written authorization and
                          consent, you are not allowed to use the logo and other words, graphics and combinations of
                          this platform, as well as other logos, trade names, emblems, APP names, website names, service
                          names, service marks of this platform in any country or region in the world. Display, use or
                          apply for registered trademarks, domain name registration, etc. in any way, and shall not
                          express or imply to others the right to display, use, or otherwise have the right to deal with
                          the above marks. If you cause losses to us or others due to your illegal use of the above
                          logos, you shall bear all legal responsibilities.
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          <span class="bold">
                            8.4 You should respect the intellectual property rights and other legal rights/interests of
                            us and third parties, and ensure that the text, pictures, videos, software, performances and
                            other information uploaded when using the services of this platform do not infringe any
                            third party's intellectual property rights, reputation rights, Name rights, privacy rights
                            and other legitimate rights and interests, and guarantee to protect us and our employees,
                            shareholders, partners, etc. from being affected or lost due to such incidents in the event
                            of illegal events that violate the aforementioned rights and interests. We reserve the right
                            to terminate the service to you without refunding any payment if you violate the legal
                            rights/interests of us and/or other third parties, and you shall be solely responsible for
                            all indemnity and compensation we suffer as a result, including but not limited to economic
                            , loss of corporate goodwill, etc.</span>
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>8.5 Any organization or individual who believes that the content of this platform infringes
                          its intellectual property rights can submit a written notice of rights and preliminary
                          evidence of infringement to us via info@mints.cn. deal with it as soon as possible.
                        </p>
                      </div>
                    </li>

                  </ul>
                </div>
              </li>

              <li>
                <div class="rt">
                  <p>IX. About this software</p>
                  <p class="desc">
                    9.1 We develop and authorize you to download, install, log in, and use the ThinBox software (<span
                      class="bold">"this software"</span>) in accordance with the terms of this agreement.
                    <br>You can use the software in the form of APP through the mobile terminal, and at the same time,
                    we will continue to enrich the terminals and forms of your use of the software. When you use this
                    software, you should select the software version that matches your terminal, system, etc.,
                    otherwise, you may not be able to use this software normally.
                  </p>
                  <p class="desc">
                    9.2 We grant you a personal, non-transferable and non-exclusive license to use the Software to the
                    extent and in the manner defined in this Agreement and other individual product agreements. You and
                    only you can download, install, use and log in this software on a single terminal device for
                    non-commercial purposes. </p>
                  <p class="desc">9.3 You can obtain the software directly from our official website, as well as
                    authorized third-party websites and application distribution platforms. </p>
                  <p class="desc bold">9.4 If you obtain this software or an installation program with the same name as
                    this software from a third party that is not authorized by us, we cannot guarantee the normal use of
                    the software, and we will not be responsible for any loss caused to you. take no responsibility
                    whatsoever. </p>
                  <p class="desc">9.5 We may develop different software versions for different terminals, systems, etc.
                    You should download the appropriate version for installation according to the actual situation.
                    After downloading the installer, you need to follow the steps that the program prompts to install
                    properly. </p>
                  <p class="desc">9.6 If you no longer need to use this software or need to install a new version of the
                    software, you can uninstall it yourself. If you would like to help us improve our product service,
                    please let us know the reason for the uninstallation. </p>
                  <p class="desc">9.7 In order to enhance the user experience and improve the service content, we may
                    continuously strive to develop new services and provide you with software updates from time to time.
                  </p>
                  <p class="desc bold">9.8 For the purpose of improving user experience or improving service security,
                    ensuring the consistency of functions, etc., we have the right to update this software, or make
                    changes to some functional effects and service contents of this software. </p>
                  <p class="desc">9.9 After the new version of the software is released, the old version of the software
                    may not be available. We do not guarantee that the old version of the software will continue to be
                    available, nor will we continue to provide corresponding customer service and maintenance services
                    for the old version of the software. Please check and download the latest version at any time. </p>
                  <p class="desc">9.10 This software may use third-party software or technologies (including open source
                    code and public domain code that may be used by this software, the same below), and this use has
                    been legally authorized. </p>
                  <p class="desc">
                    9.11 If the software uses third-party software or technology, we will display relevant agreements or
                    other documents in accordance with relevant regulations or agreements, possibly by packaging them in
                    specific folders of the software installation package, and they may be displayed in the form of
                    "Software License Agreement", "License Agreement", "Open Source Code License" or other forms.
                  </p>
                  <p class="desc">9.12 The aforementioned relevant agreements or other documents are an integral part of
                    this agreement and have the same legal effect as this agreement, and you should abide by these
                    requirements. <span class="bold">If you fail to comply with these requirements, the third party or
                      state authority may sue you, impose fines or impose other sanctions on you, and require us to
                      assist you, and you should bear the legal responsibility yourself. </span></p>

                </div>
              </li>
              <li>
                <div class="rt">
                  <p>X. Personal Information Protection Policy</p>
                  <p class="desc">
                    We take and protect your personal information very seriously and have developed a special <span
                      class="bold"><a href="/conceal" style="color:#83878B;font-weight:bold">Thin Box Privacy
                        Policy</a></span>. Please be sure to read it before you use the services we provide.
                  </p>
                </div>
              </li>
              <li>
                <div class="rt">
                  <p>Eleven, compensation</p>
                  <p class="desc">
                    You shall be liable for any claims or demands made by any third party against us or our affiliates
                    due to your breach of this Agreement, including but not limited to litigation costs, attorney fees,
                    travel costs, settlement amounts, fines or effective laws The amount of damages, software royalties,
                    etc. stipulated in the document, and you should defend or eliminate the impact for us and protect us
                    from damage.
                  </p>
                </div>
              </li>
              <li>
                <div class="rt bold">
                  <p>XII. Limitation of Liability</p>
                  <p class="desc bold">Please know and understand that we will not be liable for any loss or damage
                    caused to you in the following circumstances:</p>
                  <ul>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          12.1 We will try our best to provide you with unobstructed, coherent and secure network
                          services, but network services may be affected by a variety of factors, we cannot guarantee
                          that the services provided to you are continuous, immediate, accurate, nor can we predict and
                          Prevent legal, technical and other risks, including but not limited to force majeure, viruses,
                          Trojan horses, hacker attacks, system instability, third-party service defects, government
                          actions and other reasons that may result in service interruption, data loss, wallet file
                          damage and other losses and risk. Our service content will be provided on an as-is basis, and
                          we do not make any form of guarantee regarding the accuracy, completeness, satisfactory
                          quality, non-infringement or suitability for a particular purpose of the service content.
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          12.2 Confirmation of the purchase of digital collections takes a certain amount of time, and
                          may not be completed in some cases, such as hardware, software or network connection failure,
                          malicious code or computer virus, payment system, and warrant registration system failures
                          that cause the purchase to fail to complete. In no event shall we be liable to you or any
                          third party for the above.
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          12.3 We reserve the right to modify, increase or decrease, cancel, suspend, interrupt or
                          terminate the provision of all or part of the services of this platform at any time without
                          prior notice to you, nor any responsibility to you and third parties. If the server needs to
                          be suspended due to system maintenance or upgrade, we will try our best to announce it in
                          advance. If the service needs to be suspended due to system maintenance or upgrade, or the
                          service is suspended due to server failure, hardware failure, or other force majeure factors,
                          we will try our best to save and restore any inconvenience and data, data, etc. caused during
                          the suspension period. recovery, we do not assume any responsibility.
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          12.4 We will try to provide accurate information in the Services as far as possible. The
                          pictures, demonstration pictures and schematic diagrams of digital collections involved in the
                          service are for reference only (the pictures are composite pictures and simulated
                          demonstration pictures). Due to space limitations, the information contained in this agreement
                          (including but not limited to digital collection function descriptions, etc.) may not be
                          complete, please refer to the specific information about the digital collection user manual.
                          We do not guarantee that the services and digital collections provided will fully meet your
                          usage requirements, or fully meet your expectations. We reserve the right to change the
                          design, specifications of the Digital Collection at any time without prior notice to you.
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          12.5 We are not responsible for the authenticity, accuracy, completeness and legality of any
                          information you obtain from this platform, such as information, content, statements or
                          advertisements of others. If any unit or individual conducts any actions through the above
                          "information", it must identify the authenticity and prevent risks carefully. Otherwise, for
                          whatever reason, we shall not bear any responsibility for any transactions and/or actions that
                          do not occur directly on this platform. DIRECT, INDIRECT, INCIDENTAL OR CONSEQUENTIAL DAMAGES
                          AND LIABILITY.</p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          12.6 We do not assume any liability that may arise from the information you provide, including
                          but not limited to the use of the information without authorization, or the information you
                          provide contains errors, inaccuracies, viruses, defamation, slander, infringement, etc. Any
                          liability arising from content or other content that is prohibited by copyright laws, privacy
                          and personal information protection laws or any other laws. We are also not responsible for
                          the loss, deletion, removal or failure of transmission of the information you provide under
                          any circumstances, and you should keep backup copies of the information you provide. We
                          reserve the right to delete or remove any information you provide at any time without notice
                          to you and without liability.
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          12.7 You acknowledge and agree that the value of digital collections is highly subjective, and
                          neither we nor any third party make any commitment to the current and future value of digital
                          collections. You agree that you will independently assess the price of digital collections
                          without reliance on our services. The blockchain registration certificate itself has no
                          intrinsic value. It is only the certificate of rights for digital collections. It cannot be
                          purchased separately from the digital collection. It must not be used as a measure of value or
                          a medium of exchange to purchase other assets, nor may it be used to purchase any assets or
                          assets. It can be exchanged with national fiat currency separately.
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          12.8 Our service content may contain links to third-party services or access to services
                          provided by third parties. These third parties are only for your convenience and do not mean
                          that we operate or participate in the operation of these services, nor do they mean that you
                          are granted access or use. You are responsible for the license of these services (including
                          but not limited to compliance with such third party's terms of use) and at your own expense to
                          access these services, and we are not responsible for the content and conduct of these
                          services. You and the third party are solely responsible for any legal actions you have with a
                          third party outside this platform, including but not limited to transactions with third
                          parties, and we do not control or support such transactions, therefore We do not take any
                          responsibility.
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          12.9 Due to the innovative nature of the products and services we provide, the current laws,
                          regulations, departmental rules and other normative documents and regulatory policies may
                          change at any time and have a significant impact on the products and services we provide. You
                          understand and agree that we cannot guarantee the continuous provision of relevant services to
                          you and maintain the initial price of your digital collections, and we may update or adjust
                          our service content as necessary, or even suspend or terminate the provision of all or part of
                          the services to you. You acknowledge and agree that in order to ensure the safety, legality
                          and order of transactions and to fulfill our anti-money laundering obligations, we have the
                          right to conduct security queries on your blockchain address. If we find that there is an
                          abnormal situation such as fraud, or you have violated laws and regulations or this agreement,
                          we have the right to take necessary measures such as shielding or restricting your use.
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          12.10 Since the digital collections we provide may contain clips from certain TV series,
                          movies, music, pictures, audio-visual works, etc., if a certain work or someone’s work is
                          removed from the entire network due to sudden policy requirements, this The platform will
                          remove its related digital collections in accordance with policy requirements, and you agree
                          that we will not be held responsible. After removal, you may not be able to purchase and
                          publicly display these digital collections, but the digital collections you have purchased can
                          still be viewed in your personal center.
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          12.11 The products and services we provide depend on the [Digital Collection Warrant
                          Registration Chain] that we operate and maintain. All smart contracts are executed and occur
                          on decentralized ledgers. We have no control over the smart contracts, nor can we make any
                          guarantees and commitments. You acknowledge and agree that we will not be liable to you for
                          any consequences and responsibilities arising therefrom. At the same time, we are not
                          responsible for any loss caused by the blockchain or any other function of the flow network or
                          any e-wallet, including but not limited to the most recently reported (or not reported at all)
                          blockchain-related Any network issues, including technical node issues or any other issues
                          that result in loss of funds.
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          12.12 You hereby acknowledge and accept: for any direct or indirect loss suffered by you as a
                          result of your use of the service, including but not limited to any damages, liabilities,
                          requests arising from delays, inaccuracies, errors and omissions in the service content or
                          services , losses or expenses, we and our affiliates do not accept any responsibility.
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          12.13 For some reasons, such as the adjustment of the company's business strategy, we may
                          close this platform and its servers, which will cause you to no longer be able to enjoy the
                          relevant services provided by us through this platform, such as unique digital collections.
                          You understand and agree that we will not be liable to you for any consequences and
                          responsibilities arising therefrom. However, this behavior will not cause you to lose the
                          relevant rights of the digital collections you have already enjoyed. The relevant information
                          of the digital collections you hold is still recorded on the relevant blockchain, and you can
                          still view the digital collections you hold through relevant channels. We will provide you
                          with the relevant channels at that time.
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>

              <li>
                <div class="rt">
                  <p>XIII. Applicable Law and Dispute Resolution</p>
                  <p class="desc">
                    The interpretation and execution of this agreement shall be governed by the laws of the People's
                    Republic of China. If any provisions of this agreement are invalid due to conflict with the laws of
                    the People's Republic of China, these provisions will be re-analyzed as closely as possible to the
                    original provisions of this agreement, and other provisions of this agreement shall still have full
                    force and effect. In the event of any inconsistency between the content of this Agreement and
                    applicable mandatory legal provisions, such mandatory legal provisions shall prevail.
                    <span class="bold">Any disputes arising from the performance of this agreement shall first be
                      resolved through negotiation between the two parties; if the negotiation fails, either party may
                      file a lawsuit with the competent people's court in the place where Beijing Bangbox Technology
                      Co., Ltd. is located. </span>
                  </p>
                </div>
              </li>

              <li>
                <div class="rt">
                  <p>14. Other Terms</p>
                  <ul>
                    <li>
                      <div class="rt">
                        <p>
                          14.1 When you use our services, you may need to comply with other agreements or terms
                          depending on the content of the services involved. This agreement and other agreements or
                          terms together constitute the entire agreement between us and you regarding the use of our
                          services. You can only use the related services on the premise of fully agreeing to the
                          complete agreement.

                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>14.2 You and us, namely Beijing Baohe Technology Co., Ltd., are independent entities, and
                          this agreement does not constitute an agency, partnership, joint venture or employment
                          relationship between the two parties under any circumstances. </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>14.3 The right to interpret this agreement and related services belongs to Beijing Bangbox
                          Technology Co., Ltd. </p>
                      </div>
                    </li>
                    <li>

                      <div class="rt">
                        <p>14.4 The headings of this agreement are for reference only and do not serve as a basis for
                          interpreting the contents of the terms. </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>

            </ul>
          </section>
        </article>

      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "about",
    mounted() {
      window.scrollTo(0, 0);
    }
  }

</script>

<style scoped="scoped">
  .contentTerms {
    background: #0C0C0C;
  }

  * {
    margin: 0;
    padding: 0;
  }

  a {
    word-break: break-all;
  }

  a:link {
    color: #5bb6fa;
  }

  /* unvisited link */
  a:visited {
    color: #935171;
  }

  /* Links that have been visited */
  a:hover {
    text-transform: uppercase;
  }

  /* Move the mouse pointer over the link */
  /* a:active {background:#FF704D;} the link being clicked */

  li {
    list-style: none;
  }

  .content {
    /* padding-top: 56px; */
  }

  .intro {
    color: #BDBDBD;
    font-size: 12px;
  }

  .topTitle {
    color: #f5f4f9;
    font-size: 17px;
    font-weight: bold;
    text-align: center;
    display: inline-block;
    margin-bottom: 17px;
  }

  .topTitle img {
    width: 47px;
    height: 47px;
    object-fit: cover;
    display: inline-block;
    vertical-align: middle;
  }

  .content {
    /* position: absolute;
    top: 15px;
    right: 16px;
    left: 16px;
    bottom: 0;
    background-color: #0C0C0C;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.5);
    border-radius: 4px; */
  }

  .mainDiv {
    /* position: absolute;
    top: 15px;
    right: 0;
    left: 0;
    bottom: 15px;
    overflow-y: scroll;
    padding: 15px 15px 0 15px;
    box-sizing: border-box;
    text-align: left; */

    padding: 10px;
    font-size: 14px;
    color: #8d8f9f;
    line-height: 1.75;
  }

  .main {}

  .privacy-content {
    color: #83878B;
    font-size: 12px;
  }

  .privacy-content ul li {
    /* display: flex;
    align-items: flex-start; */
  }

  .privacy-content>ul>li {}

  .privacy-content ul li .lf {
    text-align: right;
  }

  .privacy-content ul li .rt {
    text-align: left;
  }

  .privacy-content ul lip {}

  .privacy-content .desc {}

  .privacy-content .desc a {
    color: #83878b;
  }

  .bold {
    font-weight: bolder;
  }

</style>



// WEBPACK FOOTER //
// src/components/userAgreementUs.vue